import styled from '@emotion/styled';
import Text from '../Text';
import { SubDetailsType } from './types';
import StyledLink from '../StyledLink';

const Wrapper = styled.div`
  > a:hover {
    color: var(--all-ports);
    text-decoration: underline;
  }
`;

const Dot = styled.div`
  height: 4px;
  width: 4px;
  border-radius: 100%;
  background-color: var(--mischka);
`;

interface ISubDetailsProps {
  data: SubDetailsType;
}

const SubDetails = ({ data }: ISubDetailsProps) => {
  const visibleData = data.filter(eachData => eachData.isVisible ?? true);

  if (visibleData.length === 0) {
    return null;
  }

  return (
    <Wrapper className="align-center gap-8">
      {visibleData.map((eachData, index) => {
        const nodes = index === 0 ? [] : [<Dot key={index} />];

        if (eachData.type === 'text') {
          nodes.push(
            <Text key={eachData.key} size="xs">
              {eachData.children}
            </Text>,
          );
        } else if (eachData.type === 'link') {
          nodes.push(
            <StyledLink key={eachData.key} size="xs" to={eachData.to}>
              {eachData.children}
            </StyledLink>,
          );
        }

        return nodes;
      })}
    </Wrapper>
  );
};

export default SubDetails;
